import { Card, CardBody, Col } from "reactstrap";
import DashboardCommonHeader from "../../../../CommonComponents/DashboardCommonHeader/DashboardCommonHeader";
import { OurTotalGrowthTitle } from "../../../../../Constants/Constants";
import ReactApexChart from "react-apexcharts";
import { GrowthChart } from "../../../../../Data/General/Dashboard/Default";

const OurTotalGrowth = () => {
  return (
    <Col xl="7" md="6">
      <Card>
        <DashboardCommonHeader title={OurTotalGrowthTitle} dropdownClass="dropdown-toggle" />
        <CardBody>
          <div id="growth-chart">
            <ReactApexChart type="line" options={GrowthChart} series={GrowthChart.series} height={270} />
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default OurTotalGrowth;
